module.exports = __webpack_public_path__ + "static/img/tutoriales sin texto utopie.a648b1b3.jpg";